// src/services/religionService.js
import apiClient from "./apiClient";

const endpoints = { base: "/admin/religion" };

// Keep backend's expected casing
const normalizeStatus = (s) => (String(s).toLowerCase() === "publish" ? "Publish" : "UnPublish");

// GET: /admin/religion
export async function getAllReligions({ signal } = {}) {
  const res = await apiClient.get(endpoints.base, { signal });
  return res.data; // { statusCode, success, message, data: [...] }
}

// POST: /admin/religion  (JSON body)
export async function addReligion({ name, status }, { signal } = {}) {
  const payload = { name, status: normalizeStatus(status) };
  const res = await apiClient.post(endpoints.base, payload, {
    signal,
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
}

// PUT: /admin/religion  (JSON body)
export async function updateReligion({ id, name, status }, { signal } = {}) {
  const payload = { id };
  if (typeof name !== "undefined") payload.name = name;
  if (typeof status !== "undefined") payload.status = normalizeStatus(status);

  const res = await apiClient.put(endpoints.base, payload, {
    signal,
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
}

// DELETE: /admin/religion  (JSON body)
export async function deleteReligion({ id }, { signal } = {}) {
  const res = await apiClient.delete(endpoints.base, {
    signal,
    data: { id },
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
}
